import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { configureAgGridGlobalDefaults } from './app/shared/ag-grid/ag-grid-global-defaults';

configureAgGridGlobalDefaults();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
